module.exports = __webpack_public_path__ + "0bd5d245b3ad371807c16a77edfe48c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/About/Assets/TKCP-Logo.jpg
// module id = 1371
// module chunks = 0